import request from '@/utils/request'

// 密码登录
export const login = (data = {}) => request({ url: `/api/uc/v1/estateLogin/passwordLogin`, method: 'post', data })

// 令牌登录
export const optLogin = (data = {}) => request({ url: `/api/uc/v1/estateLogin/optLogin`, method: 'post', data })

export const getUserByToken = (data = {}) => request({ url: `/api/uc/v1/estateLogin/getUserByToken`, method: 'post', data })

export const logout = (data = {}) => request({ url: `/api/uc/v1/estateLogin/logOut`, method: 'post', data })

export const changeMobilePhone = (data = {}) => request({ url: `/api/uc/v1/estateLogin/changeMobilePhone`, method: 'post', data })

export const checkVerifyCode = (data = {}) => request({ url: `/api/uc/v1/estateLogin/checkVerifyCode`, method: 'post', data })

export const forgetPassword = (data = {}) => request({ url: `/api/uc/v1/estateLogin/forgetPassword`, method: 'post', data })

export const modifyPassword = (data = {}) => request({ url: `/api/uc/v1/estateLogin/modifyPassword`, method: 'post', data })

export const sendSmsCode = (data = {}) => request({ url: `/api/uc/v1/estateLogin/sendSmsCode`, method: 'post', data })

export const staffPermissionList = (data = {}) => request({ url: `/api/uc/v1/permission/userAppPermissionList`, method: 'post', data })

export const getTenantTypeByToken = (data = {}) => request({ url: `/api/uc/v1/tenant/getTenantTypeByToken`, method: 'post', data })

// 绑定动态令牌
export const checkOpt = (data = {}) => request({ url: `/api/uc/v1/user/checkOpt`, method: 'post', data })

export const getOptInfo = (data = {}) => request({ url: `/api/uc/v1/user/getOptInfo`, method: 'post', data })

export const getOptTicket = (data = {}) => request({ url: `/api/uc/v1/user/getOptTicket`, method: 'post', data })

export const restOptInfo = (data = {}) => request({ url: `/api/uc/v1/user/restOptInfo`, method: 'post', data })

export const unbindOptInfo = (data = {}) => request({ url: `/api/uc/v1/user/unbindOptInfo`, method: 'post', data })

// 登录日志
export const loginOperationLogPage = (data = {}) => request({ url: `/api/estate/v1/system/loginOperationLogPage`, method: 'post', data })

export const loginOperationLogCount = (data = {}) => request({ url: `/api/estate/v1/system/loginOperationLogCount`, method: 'post', data })
